"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_1 = require("../../../tools/styled");
exports.TextArea = react_1.default.forwardRef((props, ref) => (jsx_runtime_1.jsx(TextField, Object.assign({ ref: ref }, props, { className: `${props.className ? props.className : ''} ${props.isValid === true ? 'valid' : props.isValid === false ? 'invalid' : ''}`, "data-invalid": props.isValid === false }), void 0)));
const TextField = styled_1.styled.textarea `
  margin: 0.1rem 0 0 0;
  font-family: 'Roboto', sans-serif !important;
  font-size: 16px !important;
  outline: none;
  width: 100%;
  padding: 8px 12px;
  color: inherit;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-width: 0 0 2px 0;
  border-color: #ced4da;

  &[data-invalid] {
    border-color: ${({ theme }) => theme.colors.danger};
  }
`;
//# sourceMappingURL=index.js.map